import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { Payroll } from '../../../models/salaries/payroll';
import { PayrollDetail } from '../../../models/salaries/payroll.detail';
import { PayrollFilter } from '../../../models/salaries/payroll.filter';
import { AlertService } from '../../../services/alert.service';
import { PayrollService } from '../../../services/payroll.service';
import { PAYROLL_TYPES } from '../../../contants/PAYROLL_TYPES';

@Component({
	selector: 'app-payroll-form',
	templateUrl: './payroll-form.component.html',
	styleUrls: ['./payroll-form.component.css']
})
export class PayrollFormComponent implements OnInit {
    payroll: Payroll = new Payroll();
    payrollTableType: string = undefined;
    isLoading: boolean = false;

	constructor(
        private _payrollService: PayrollService,
		private _activatedRoute: ActivatedRoute,
        private _alertService: AlertService
	) { }

	ngOnInit() {
        this._activatedRoute.params.subscribe(
			val => {
				this.init();
			}
		)
    }
    
    private init(){
        let id = this._activatedRoute.snapshot.params['id'];        
        if (id != 0) {
			this._payrollService.getExistingPayroll(id).subscribe(
				result => {
					if (result == undefined) {
						this.payroll.id = 0;
					}
					else {
						this.payroll = result;
                        this.payrollTableType = this.payroll.type;
					}
				}
			);
		}
    }

	getTotal(propName: string){
		let total = 0;
		this.payroll.payrollDetails.forEach(x => total += x[propName]);
		return total;
    }
    
    getDeduction(details: PayrollDetail){
        return details.cashAdvanceDeduction + details.hdmf + details.hdmfLoan + details.phic + details.sss + details.sssLoan + details.tax + details.lateDeduction;
    }

    getNetPay(details: PayrollDetail){
        if(this.payrollTableType === PAYROLL_TYPES.bookKeeper){
            return (details.tripCount * details.bookKeeperRatePerTrip) - this.getDeduction(details) + details.otPay;
        }

        return details.recordedGrossPay - this.getDeduction(details) + details.otPay;
    }

    getTotalDeduction(){
        let total = 0;
        this.payroll.payrollDetails.forEach(x => total += this.getDeduction(x));
        return total;
    }

    getTotalNetPay(){
        let total = 0;
        this.payroll.payrollDetails.forEach(x => total += this.getNetPay(x));
        return total;
    }

    getTotalGrossPayForBookkeeper(){
        let total = 0;
        this.payroll.payrollDetails.forEach(x => total += x.tripCount * x.bookKeeperRatePerTrip);
        return total;
    }

	fetch(){
        if(this.payroll.dateFrom == undefined || this.payroll.dateTo == undefined || this.payroll.type == undefined){
            this._alertService.showError('Date From, Date To and Role is required.');
            return;
        }

		this._payrollService.initializePayroll(this.payroll.dateFrom, this.payroll.dateTo, this.payroll.type)
			.subscribe(result => {
				if(result.object != undefined){
					this.payroll = result.object;                    
                    this.payrollTableType = result.object.type;
                }
                else{
                    this.payroll.payrollDetails = [];
                    this.payrollTableType = undefined;
                    this._alertService.displayErrorResult(result.errorCollection);
                }
			});
    }

    export() {
        var filter = new PayrollFilter();
        filter.from = this.payroll.dateFrom;
        filter.to = this.payroll.dateTo;
        filter.type = this.payroll.type;

        this._payrollService.getExportUrl(filter).subscribe(
            result => {
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' });
                saveAs(blob, `${filter.type} - ${filter.from}-${filter.to}.xlsx`)
            }
        )
    }
    
    print() {
        window.open(`${window.location.origin}/print.html?id=${this.payroll.id}`, '_blank')
    }
    
    save() {
        this.isLoading = true;
        if(this.payroll.id == 0){
            this.create();
        }
        else{
            this.update();
        }
    }

    private create(){
        this._payrollService.addPayroll(this.payroll)
            .subscribe(result => {
                if (result.object != null) {
                    this.payroll = result.object;
                    this._alertService.showSuccess('Payroll data saved.');
                }
                else{
                    this._alertService.displayErrorResult(result.errorCollection);
                }
                this.isLoading = false;
            });
    }

    private update(){
        this._payrollService.updatePayroll(this.payroll)
            .subscribe(result => {
                if (result.object != null) {
                    this.payroll = result.object;
                    this._alertService.showSuccess('Payroll data updated.');
                }
                else{
                    this._alertService.displayErrorResult(result.errorCollection);
                }
                this.isLoading = false;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/salaries/payroll-form/payroll-form.component.ts